module.exports = __webpack_public_path__ + "img/Dantam Fashion 13.0fac6d7f.jpg";